<template>
    <div v-if="currentAssignment">
        <approve
            v-if="showReviewBox"
            @onSave="handleSave"
            @kickback="alert('unfinalize',hash)"
            @onClose="closeReviewBox"
            @onNext="nextReviewBox"
            @onPrevious="prevReviewBox"
            @onApprove="handleApproval"
            :entityId="entityId"
            :assignment="currentAssignment"
            :next-start="isNextStart"
            :prev-start="isPrevStart"
            :enableProBooks="enableProBooks"
            :canApprove="canApprove"
        />
    </div>
    <div>
        <assignment-overrides-list
            v-if="showAssignmentOverrideList"
            @save="addAssignmentOverride"
            :assignment="currentAssignment"
            :enableProBooks="enableProBooks"
            :showProjects="showProjects"
            :showAssignedProjects="showAssignedProjects"
            @close="showAssignmentOverrideList=false"
        />
    </div>
    <div class="m-top-20 panel panel-info">
        <div v-if="showModal" class="modalDialog is-active" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" aria-hidden="true" @keyup.esc="modalClose">
            <div class="modal-contents">
                <div>
                    <a title="Close" class="close" @click="showModal=false">X</a>
                    <h3><slot id="modal-title" name="header">Alert</slot></h3>
                    <hr />
                </div>
                <div>
                    <slot id="modal-description" name="body">
                        <span @click="showModal=false" v-html="modalMessage"></span>.
                    </slot>
                    <hr />
                </div>
                <div class="right">
                    <button class="btn btn-primary" @click="showModal=false">Close</button>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <div class="panel-heading centered bold big ">
            <div class="col-xs-7 centered bigger">
                <span v-if="myApprovalsOnly">Starts to Approve</span><span v-else>Roster</span>
            </div>
            <div class="right" style="display: inline-flex;">
                <span class="p-right-5"><div v-if="loading" class="inline-loader"></div></span>
                <!-- <span class="btn btn-primary" @click="getRoster()" ><strong>Search</strong></span>  -->
                <!-- <span class="btn btn-default" @click="resetSearch"><strong>Reset</strong></span>  -->
                <button v-if="showAssignedProjects" class="btn btn-warning m-right-5" @click="toggleAssignmentOverrides" ><strong>View Overrides</strong></button>
                <button v-if="useNewApproval" class="btn btn-danger m-right-5" @click="toggleToApprove" ><strong><span v-if="myApprovalsOnly">See All Starts</span><span v-else>See My To Do</span></strong></button>
                <button v-if="canSeeRates || adminAccess" class="btn btn-primary m-right-5" @click="toggleRates" ><strong>{{ this.showRates ? 'Hide' : 'Show' }} Rates</strong></button>
                <button class="btn btn-info m-right-5" @click="toggleSSN" ><strong>{{ this.showSSN ? 'Hide' : 'Show' }} SSNs</strong></button>
                <!-- <button v-if="canSeeRates || adminAccess" class="btn btn-warning m-right-5" @click="saveRosterData" ><strong>Save</strong></button> -->
                <div class="btn-group" v-if="usesSplitForms">
                    <button type="button" class="btn btn-default dropdown-toggle m-right-10" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Other Actions <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                        <li><a @click="exportStarts()">Generate Start Packets</a></li>
                        <li><a @click="generateIndividualStartFormModal=true">Generate Individual Start Forms</a></li>
                    </ul>
                </div>
                <span class="btn btn-default m-right-5 bold" @click="reportPayrollStarts()">Save to CSV</span>
                <span class="btn btn-success m-right-5 bold" @click="exportStarts()">Save PDFs</span>
                <span v-if="adminAccess" class="btn btn-danger right m-left-5 bold" @click="exportStartsPropay()">Export</span>
            </div>
            <div class="clear"></div>
        </div>
        <ag-grid
            :name="name"
            :ref="reference"
            :iteration="iteration"
            :width="width"
            :height="height"
            :columns="columnDefs"
            :row-data="rowData"
            :options="gridOptions"
            sidebar="filters"
            :filter-order="filterOrder"
            :classes="'ag-theme-balham ' + (loading ? 'opacity-25' : '')"
        />
    </div>
    <oasis-modal v-if="generateIndividualStartFormModal" style="z-index: 950" @keyup.enter="generateIndividualStartFormModal=false" @keyup.esc="generateIndividualStartFormModal=false">
        <template v-slot:header>
            <span title="Close" class="close" @click="generateIndividualStartFormModal=false">X</span>
            Generate Individual Start Forms
        </template>
        <template v-slot:body>
            <div v-for="(name, key) in availableForms">                
                <input type="checkbox" :value="key" :id="key" :name="key" v-model="selectedForms" :disabled="loading" />
                <label :for="key" class="m-left-10">{{ name }}</label>
            </div>
            <div class="clear"></div>
        </template>
        <template v-slot:footer>
            <span class="p-right-5"><div v-if="loading" class="inline-loader" style="display:inline-block;vertical-align:middle;"></div></span>
            <button :disabled="loading" class="btn btn-default" @click="generateIndividualStartFormModal=false">Cancel</button>
            <button :disabled="loading" class="btn btn-primary" @click="exportSelectedStartForms()">OK</button>
        </template>
    </oasis-modal>
</template>

<script>
import 'regenerator-runtime/runtime';
import Axios from '../classes/Axios.js';
import DateField from './DateField.vue';
import AgGrid from './AgGrid.vue';
import {defineComponent, ref} from 'vue';
import oasisModal from './oasis-modal.vue';
import PollingMixin from '../mixins/PollingMixin.js';
import COAMixin from '../mixins/COAMixin.js';
import Approve from '../components/Approve.vue';
import AssignmentOverridesList from './AssignmentOverridesList.vue';

export default defineComponent ({
    name: "Roster",

    mixins: [PollingMixin, COAMixin],

    emits: ['changed'],

    components: {
        'date-field': DateField,
        'ag-grid': AgGrid,
        'oasis-modal': oasisModal,
        Approve,
        'assignment-overrides-list': AssignmentOverridesList,
    },

    props: {
        adminAccess: {
            type: Boolean,
            required: false,
            default: false,
        },
        name: {
            type: String,
            required: false,
            default: 'roster',
        },
        reference: {
            type: String,
            required: false,
            default: 'roster',
        },
        classes: {
            type: [ String, Array ],
            required: false,
            default: 'form-control'
        },
        canSeeRates: {
            type: Boolean,
            required: false,
            default: false
        },
        // user: {
        //     type: Object,
        //     required: true,
        // }
    },

    data() {
        return {
            localValueFormatter: function localValueFormatter(params) {
                var value = params.value;
                if (!value) return 'Non Union';
                return value;
            },
            generateIndividualStartFormModal: false,
            loading: false, // spinner
            iteration: 0,
            locale: window.navigator.userLanguage || window.navigator.language || 'en-US', // 'fr-fr' // test stuff
            oasisApi: new Axios('/restv2'),
            oasisV3Api: new Axios('/restv3'),
            link: '',
            showModal: false,
            modalMessage: '',
            showAllShows: false,
            usesSplitForms: false,
            availableForms: {},
            selectedForms: ref([]),
            showRates: false,
            showSSN: false,
            propayHost: '',
            entityId: undefined,
            // To allow reviews
            useNewApproval: false,
            showReviewBox: false,
            showAssignmentOverrideList: false,
            showProjects: false,
            showAssignedProjects: false,
            currentRowId: undefined,
            currentAssignment: undefined,
            enableProBooks: false,
            myApprovalsOnly: false,
            privateSSN: [],

            // AG Grid
            gridApi: undefined,
            allStarts: [],
            startsToApprove: [],
            approvableStartIds: [],
            columnDefs: undefined,
            sidebar: undefined,
            filterOrder: undefined,
            currentFilters: undefined,
            gridChanged: false,
            gridOptions: {
                singleClickEdit: false,
                undoRedoCellEditing: false,
                enterMovesDown: false,
                enterMovesDownAfterEdit: false,
                rowSelection: 'multiple',
                suppressContextMenu: true,
                suppressRowClickSelection: true, // Prevent selection/deselection when clicking on a start
                enableRangeSelection: true,
                defaultColDef: {
                    resizable: true,
                    sortable: true,
                    menuTabs: [],
                    suppressSizeToFit: false,
                    headerCheckboxSelectionFilteredOnly: true,
                    floatingFilter: true,
                    filterParams: {
                        suppressMiniFilter: false,
                        defaultToNothingSelected: true,
                        buttons: ['reset', 'apply'],
                        debounceMs: 200
                    }
                },

                // Excel
                defaultExcelExportParams: {
                    onlySelected: true
                },
                onGridReady: (event) => {
                    this.$refs[this.reference].onGridReady(event);
                    this.gridApi = event.api;

                    // Handle future AG Grid deprecation
                    if (this.gridApi && this.gridApi.columnController && this.gridApi.columnController.columnApi) {
                        this.gridApi.columnController.columnApi.setColumnVisible('approve', this.myApprovalsOnly);
                        this.gridApi.columnController.columnApi.setColumnVisible('active_project', this.showOverrides);
                    } else if (this.gridApi && this.gridApi.columnApi) {
                        this.gridApi.columnApi.setColumnVisible('approve', this.myApprovalsOnly);
                        this.gridApi.columnApi.setColumnVisible('active_project', this.showOverrides);
                    } else {
                        debugger;
                    }
                    // if (this.currentFilters) {
                    //     this.gridOptions.api.setFilterModel(this.currentFilters);
                    // }
                },
                onCellClicked: (event) => {
                    // if clicked on first row, load the assignment
                    if ((event.column.getColId() === 'approve') && event && event.data && event.data.hash) {
                        this.reviewAssignment(event)
                    } else if (event.column.getColId() === 'job_title_override' && event && event.data && event.data.hash) {
                        this.openAssignment(event.data.hash)
                    } else if (event.column.getColId() === 'active_project' && event && event.data && event.data.hash) {
                        this.toggleAssignmentOverrides(event.data)
                    } else if (event.column.getColId() === 'override_count' && event && event.data && event.data.hash) {
                        this.toggleAssignmentOverrides(event.data)
                    }
                },
                onRowDataUpdated: (event) => {
                    this.gridChanged = true;
                },
            }
        }
    },

    computed: {
        width() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return '100%';
        },

        height() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return window.innerHeight * 0.63 + 'px';
        },

        rowData() {
            if (this.myApprovalsOnly) {
                return this.startsToApprove;
            } else {
                return this.allStarts;
            }
        },
        isNextStart() {
            if (!this.rowData || !this.rowData.length) return false;
            else if (!this.currentRowId && this.rowData.length > 1) return true;
            else if (this.currentRowId + 1 === this.rowData.length) return false
            else return true;
        },

        isPrevStart() {
            if (!this.rowData || !this.rowData.length) return false;
            else if (!this.currentRowId) return false;
            else return true;
        },

        canApprove() {
            return this.approvableStartIds.includes(this.currentAssignment.id);
        },

        today() {
            let date = new Date();
            var day = date.getDate();
            var monthIndex = date.getMonth();
            var year = date.getFullYear();

            return year + '-' + this.pad(monthIndex * 1 + 1) + '-' + this.pad(day);
        },

        showOverrides() {
            if (this.showAssignedProjects === true) return true;
            return false;
        }

        // isArchived() {
        //     if (!this.entity) return false;
        //     return parseInt(this.entity.status) === 0;
        // },
    },

    methods: {
        createDialog(message) {
            this.modalMessage = message;
            this.showModal = true;
        },

        async getRoster() {
            this.loading = true;
            // this.rowData = undefined;
            // const endpoint = this.myApprovalsOnly ? '/getStarts/toApprove' : '/getStarts/allStarts';
            let query = {};

            let queryString = Object.keys(query).map(key => key + '=' + query[key]).join('&');

            // Keep filters after load
            const filters = this.gridOptions.api.getFilterModel();
            if (filters && typeof filters === 'object' && Object.keys(filters).length) {
                this.currentFilters = filters;
            }

            // console.log(query, queryString);
            /*
            try {
                const response = await this.oasisApi.getAllPages(endpoint + '?' + queryString);
                // console.log(response);
                if (response && response.data && response.data.results) {
                    this.rowData = response.data.results;
                } else {
                    this.rowData = [];
                }
                this.$emit('changed', this.rowData);
            } catch (error) {
                console.log(error);
                this.loading = false;
                return false;
            };
            */
            try {
                let endpoint = '/getStarts/allStarts';
                const all = await this.oasisApi.getAllPages(endpoint + '?' + queryString);
                // console.log(all);
                if (all && all.data && all.data.results) {
                    this.allStarts = all.data.results;
                } else {
                    this.allStarts = [];
                }

                endpoint = '/getStarts/toApprove';
                const toApprove = await this.oasisApi.getAllPages(endpoint + '?' + queryString);
                // console.log(toApprove);
                if (toApprove && toApprove.data && toApprove.data.results) {
                    this.startsToApprove = toApprove.data.results;
                } else {
                    this.startsToApprove = [];
                }

                this.approvableStartIds = this.startsToApprove.map((start) => start.id);
                this.$emit('changed', this.rowData);

            } catch (error) {
                console.log(error);
                this.loading = false;
                return false;
            } finally {
                this.iteration++;
                this.loading = false;
            }

        },

        getAvailableForms() {
            const endpoint = '/entity'; 
            this.oasisApi.get(endpoint).then(response => {
                if (response && (response.status === 200 || response.status === 201) && response.data) {
                    const otherProps = JSON.parse(response.data.other_properties);
                    if (otherProps.uses_split_forms) {
                        this.usesSplitForms = true;
                    }
                    this.availableForms = otherProps.available_start_forms;

                    // Load other props here
                    if (otherProps.useNewApproval) {
                        this.useNewApproval = otherProps.useNewApproval || false; 
                    }
                    if (otherProps.showProjects) {
                        this.showProjects = otherProps.showProjects || false; 
                    }
                    if (otherProps.showAssignedProjects) {
                        this.showAssignedProjects = otherProps.showAssignedProjects || false; 
                    }
                } else if (response && response.status === 400) {
                    if (response.data.message) {
                        console.error(response.data.message);
                    } else {
                        console.error(response.data);
                    }
                } else {
                    console.error(response.data || response);
                }
                this.iteration++;
            }).catch(error => {
                console.error(error);
            });
        },

        pollQueue(queueId) {
            const endpoint = 'queues/' + queueId;
            let failMessage = 'Forms failed to generate';
            let roster = this;

            this.poll(async () => {
                let finalResponse = await this.oasisV3Api.get(endpoint).then(response => {
                    if (response && response.status === 200 && response.data) {
                        response.data.status = parseInt(response.data.status);
                        if (response.data.status <= 0 || response.data.status == 3) {
                            return response;
                        }
                    }
                    else {
                        console.error(response.data || response);
                    }
                });
                return finalResponse;
            }).then(response => {
                if (response.data.status <=0) {
                    this.createDialog(failMessage);
                }
                else if (response.data.status == 3) {
                    const jobData = JSON.parse(response.data.value);
                    if (jobData.result && jobData.result.status === 'ok') {
                        this.createDialog('<a href="' + jobData.result.url + '">Download Forms</a>');
                        this.generateIndividualStartFormModal = false;
                        this.loading = false;
                    }
                    else {
                        if (jobData.result && jobData.result.message) {
                            failMessage = jobData.result.message;
                        }
                        this.createDialog(failMessage);
                        this.loading = false;
                    }
                }
            }).catch(error => {
                this.createDialog(failMessage);
                this.loading = false;
                console.error(error);
            });

        },

        async exportSelectedStartForms() {
            const endpoint = '/printselectedstarts';
            
            const hashes = this.gridOptions.api.getSelectedRows().map((row) => row.hash) || [];
            if (hashes.length === 0) {
                this.createDialog('Please Select at least one start to print.');
                return;
            }

            const docs = this.selectedForms;
            if (docs.length == 0) {
                this.createDialog('Please Select at least one form to print.');
                return;
            }

            const data = {
                "assignmentHashes": hashes,
                "docKeys": docs
            };

            this.loading = true;

            try {
                const response = await this.oasisApi.post(endpoint, data);
                if (response && (response.status === 200 || response.status === 202) && response.data) {
                    this.pollQueue(response.data.id);
                } else if (response && response.status === 400) {
                    if (response.data.message) {
                        this.createDialog(response.data.message);
                    } else {
                        this.createDialog(response.data);
                    }
                } else {
                    console.error(response.data || response);
                }
            } catch (error) {
                console.error(error);
            }
        },

        getSelectedData() {
            if (!this.gridOptions || !this.gridOptions.api) return [];
            return ((this.gridOptions.api || {}).getSelectedRows() || []);
        },

        getSelectedHashes() {
            if (!this.gridOptions || !this.gridOptions.api) return [];
            return ((this.gridOptions.api || {}).getSelectedRows() || []).map((row) => row.hash);
        },

        async openAssignment(assignmentId) {
            if (!assignmentId) return false;
            window.open(`/oasis/starts/approve/${assignmentId}`, '_roster');
        },

        approvalOn () {
            return this.myApprovalsOnly;
        },

        async reviewAssignment(event) {
            if (!event || !event.data || !event.data.id) {
                return false;
            }

            this.showReviewBox = true;
            this.currentAssignment = event.data;
            this.currentRowId = event.node.getRowIndexString();
        },

        closeReviewBox() {
            // if (this.currentFilters) {
            //     this.gridOptions.api.setFilterModel(this.currentFilters);
            // }
            this.showReviewBox = false;
            this.currentAssignment = undefined;
        },

        async addAssignmentOverride(event) {
            if (!event || !event.data || !event.data.id) {
                return false;
            }

            this.showAssignmentOverrideList = true;
            this.currentAssignment = event.data;
            this.currentRowId = event.node.getRowIndexString();
        },

        closeAssignmentOverrideBox() {
            // if (this.currentFilters) {
            //     this.gridOptions.api.setFilterModel(this.currentFilters);
            // }
            this.showAssignmentOverrideList = false;
            this.currentAssignment = undefined;
        },

        nextReviewBox(advance=true) {
            this.currentAssignment = undefined;
            if (advance) this.currentRowId++;
            const row = this.gridApi.getDisplayedRowAtIndex(this.currentRowId)
            if (row) this.currentAssignment = this.gridApi.getDisplayedRowAtIndex(this.currentRowId).data;
        },

        prevReviewBox() {
            this.currentAssignment = undefined;
            this.currentRowId--;
            const row = this.gridApi.getDisplayedRowAtIndex(this.currentRowId)
            if (row) this.currentAssignment = this.gridApi.getDisplayedRowAtIndex(this.currentRowId).data;
        },

        // Update row data with new information
        handleSave(id=null, data=null) {
            if (!id || !data) return false;
            // remove from to approve array

            const toApproveEntry = this.startsToApprove.find((start) => parseInt(start.id) === parseInt(id));
            const allStartEntry = this.allStarts.find((start) => parseInt(start.id) === parseInt(id));

            if (toApproveEntry) {
                for (const i in data) {
                    toApproveEntry[i] = data[i];
                }
            }

            if (allStartEntry) {
                for (const i in data) {
                    allStartEntry[i] = data[i];
                }
            }
        },

        // Update grid.
        handleApproval(id=null) {
            if (!id) return false;
            // remove from to approve array
            const index = this.approvableStartIds.indexOf(id);
            if (index && index >= 0) {
                this.approvableStartIds.slice(index, 1);
            }

            // Apply the transaction to the grid to preserve sort/filters
            let nodeToRemove;
            this.gridApi.forEachNode((node) => { if(parseInt(node.data.id) === parseInt(id)) nodeToRemove = node })
            const transaction = {
                remove: [ nodeToRemove.data ]
            };
            this.gridApi.applyTransaction(transaction);
        },

        async loadCOA() {
            const currentTime = new Date().getTime();
            await this.getProbooksResources(currentTime);

            const COAObj = JSON.parse(window.localStorage.getItem(this.entityId + '#'));
            if ((COAObj.accounts && COAObj.accounts.length > 0) || (COAObj.freeFields && COAObj.freeFields.length > 0) || (COAObj.series && COAObj.series.length > 0) || (COAObj.locations && COAObj.locations.length > 0) || (COAObj.sets && COAObj.sets.length > 0)) {
                this.enableProBooks = true;
            }
        },

        exportToExcel() {
            const hashes = this.gridOptions.api.getSelectedRows().map((row) => row.hash) || [];
            if (hashes.length === 0) {
                this.createDialog('Please Select at least one item to export.');
                return;
            }
            this.gridOptions.api.exportDataAsExcel();
        },

        async reportPayrollStarts() {
            const endpoint = '/reportPayrollStarts';
            const hashes = this.gridOptions.api.getSelectedRows().map((row) => row.hash) || [];
            if (hashes.length === 0) {
                this.createDialog('Please Select at least one item to export.');
                return;
            }
            let data = { hashes };

            this.loading = true;
            try {
                const response = await this.oasisApi.post(endpoint, data);
                if (response && (response.status === 200 || response.status === 201) && response.data) {
                    this.createDialog(response.data);
                } else if (response && response.status === 400) {
                    if (response.data.message) {
                        this.createDialog(response.data.message);
                    } else {
                        this.createDialog(response.data);
                    }
                } else {
                    this.createDialog(response.data || response);
                }
            } catch (error) {
                console.log(error);
                this.loading = false;
            }
            this.loading = false;
        },

        async exportStarts() {
            const endpoint = '/export/starts';
            const hashes = this.gridOptions.api.getSelectedRows().map((row) => row.hash) || [];
            if (hashes.length === 0) {
                this.createDialog('Please Select at least one item to export.');
                return;
            }
            let data = { hashes };

            this.loading = true;
            try {
                const response = await this.oasisApi.post(endpoint, data);
                if (response && (response.status === 200 || response.status === 201) && response.data) {
                    this.createDialog((response.data || {}).message || response.data);
                } else if (response && response.status === 400) {
                    if (response.data.message) {
                        console.error(response.data.message);
                    } else {
                        console.error(response.data);
                    }
                } else {
                    console.error(response.data || response);
                }
            } catch (error) {
                console.log(error);
                this.loading = false;
            }
            this.loading = false;
        },

        async exportStartsPropay() {
            const endpoint = '/export/startsPropay';
            const hashes = this.gridOptions.api.getSelectedRows().map((row) => row.hash) || [];
            if (hashes.length === 0) {
                this.createDialog('Please Select at least one item to export.');
                return;
            }
            let data = { hashes };

            this.loading = true;
            try {
                const response = await this.oasisApi.post(endpoint, data);
                if (response && (response.status === 200 || response.status === 201) && response.data) {
                    this.createDialog('Starts exported.');
                } else if (response && response.status === 400) {
                    if (response.data.message) {
                        this.createDialog(response.data.message);
                    } else {
                        this.createDialog(response.data);
                    }
                } else {
                    this.createDialog(response.data || response);
                }
            } catch (error) {
                console.log(error);
                this.loading = false;
            }
            this.loading = false;
        },

        resetSearch() {
            const now = new Date();
            const today = now.toISOString().split('T')[0];
            const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 31).toISOString().split('T')[0];
            if (this.allStarts) this.allStarts = [];
            if (this.startsToApprove) this.startsToApprove = [];
            if (this.approvableStartIds) this.approvableStartIds = [];
            this.searchQueryDateStart = startDate;
            this.searchQueryDateEnd = today;
        },

        caseInsensitiveComp(valueA, valueB) {
            const a = String(valueA);
            const b = String(valueB);
            return a.toLowerCase().localeCompare(b.toLowerCase());
        },

        toggleRates() {
            this.showRates = !this.showRates;
            this.gridOptions.columnApi.setColumnsVisible(['hourly_rate', 'rate', 'rate_unit'], this.showRates);
        },

        async toggleSSN() {
            // Fetch SSN
            if (!this.showSSN) {
                try {
                    this.loading = true;
                    let message = '';
                    const endpoint = 'employer/getSSN';
                    const response = await this.oasisV3Api.get(`/${endpoint}`);
                    if (response && response.status === 200 && response.data && response.data.results) {
                        this.privateSSN = response.data.results;
                    } else if (Array.isArray(response.data.errorMessages)) {
                        const errorMessages = response.data.errorMessages;
                        for (const i in errorMessages) {
                            if (typeof errorMessages[i].message !== 'string') continue;
                            message += errorMessages[i].message || '' + "<br>";
                        }
                        console.log(message);
                    } else {
                        message += response.data.message || response.data + "<br>";
                        console.log(message);
                    }
                } catch (error) {
                    console.log(error);
                    this.loading = false;
                    return false;
                } finally {
                    this.loading = false;
                    this.gridChanged = true;
                }
            }

            this.showSSN = !this.showSSN;
            this.gridOptions.columnApi.setColumnsVisible(['employee_tin'], this.showSSN);
        },

        async saveRosterData(data=null) {
            if (!data) {
                return;
            }
            // console.log(data);
            // for (const i in this.rowData) {
            //     const assignment = this.rowData[i];
            //     if (!assignment.id) continue
            //     console.log(assignment)
            // }
        },

        async saveRosterItem(type=null, id=null, data=null) {
            if (!assignment || !id || !data) {
                console.log('No id or data');
                return null;
            }

            let endpoint, message
            if (type === 'assignment') {
                endpoint = '/assignments';
            } else if (type === 'employee') {
                endpoint = '/employees';
            } else {
                console.log('Incorrect update type');
                return null;
            }

            try {
                this.loading = true;
                const response = await this.oasisV3Api.patch(`/${endpoint}/${ele.id}`, data);
                        if (response && response.status == 200 || response.status == 201) {
                        } else if (Array.isArray(response.data.errorMessages)) {
                            const errorMessages = response.data.errorMessages;
                            for (const i in errorMessages) {
                                if (typeof errorMessages[i].message !== 'string') continue;
                                message += 'Row' + count + '(' + username + ')' + ' - ' + (errorMessages[i].message || '') + "<br>";
                            }
                        } else {
                            message += 'Row' + count + '(' + username + ')' + ' - ' + (response.data.message || response.data + "<br>");
                        }
            } catch (error) {
                console.log(error);
                this.loading = false;
                return false;
            };
            this.loading = false;
            this.gridChanged = false

            if (message) {
                this.createDialog({ "title": "Warning", "body": errorMeg, "buttonNo": false, "buttonYesLabel": "OK"  });
            }
            return;
        },

        toggleToApprove() {
            this.myApprovalsOnly = !this.myApprovalsOnly;
            this.getRoster(this.myApprovalsOnly);
            // // Handle future AG Grid deprecation
            // if (this.gridApi && this.gridApi.columnController && this.gridApi.columnController.columnApi) {
            //     this.gridApi.columnController.columnApi.setColumnVisible('approve', this.myApprovalsOnly);
            // } else {
            //     this.gridApi.columnApi.setColumnVisible('approve', this.myApprovalsOnly);
            // }
        },

        toggleAssignmentOverrides(assignment) {
            const rows = this.getSelectedData();
            if (assignment && assignment.id) {
                this.currentAssignment = assignment;   
                this.showAssignmentOverrideList = true;
            } else if (rows && rows.length === 1) {
                this.currentAssignment = rows[0];
                this.showAssignmentOverrideList = true;
            } else if (rows && rows.length > 1) {
                this.createDialog('Please select no more than one employee to view starts.');
                this.currentAssignment = undefined;
            } else {
                this.createDialog('Please select at least one employee to view starts.');
                this.currentAssignment = undefined;
            }
        },
    },

    created() {
        this.filterOrder = [
            { field: 'last_name' },
            { field: 'loanout_name' },
            { field: 'department' },
            { field: 'union_local' },
            { field: 'union_dues_withholding' },
            { field: 'union_member' },
            { field: 'job_title_override' },
            { field: 'budget_code' },
            { field: 'fringe_code' },
            { field: 'status_full' },
            { field: 'employee_state_code' },
            { field: 'time_added' },
        ];
        this.columnDefs = [
            {
                headerName: 'PP ID',
                field: 'propay_id',
                colId: 'propay_id',
                maxWidth: 120,
                width: 80,
                editable: false,
                sortable: true,
                filter: true,
                hide: !adminAccess,
                cellRenderer: (params) => params.data.propay_id ? `<a href="${this.propayHost}/admin/system/assignment/${params.data.propay_id}" target="_blank">${params.data.propay_id}</a>` : '',
                menuTabs: [],
            },
            {
                headerName: 'Approve',
                colId: 'approve',
                maxWidth: 100,
                minWidth: 100,
                editable: false,
                sortable: true,
                filter: true,
                cellRenderer: (params) => params.value ? '<span style="text-decoration: underline">View</span>' : '',
                // cellDataType: 'boolean',
                valueGetter: (params) => params.data.id && this.approvableStartIds.includes(params.data.id),
                menuTabs: [],
            },
            {
                headerName: 'Last Name',
                field: 'last_name',
                colId: 'last_name',
                checkboxSelection: true,
                headerCheckboxSelection: true,
                maxWidth: 350,
                minWidth: 100,
                editable: false,
                sortable: true,
                comparator: this.caseInsensitiveComp,
                filter: true,
                valueGetter: (params) => params.data.last_name,
                menuTabs: [],
            },
            {
                headerName: 'First Name',
                field: 'first_name',
                colId: 'first_name',
                maxWidth: 300,
                minWidth: 100,
                editable: false,
                sortable: true,
                comparator: this.caseInsensitiveComp,
                filter: true,
                valueGetter: (params) => params.data.first_name,
                menuTabs: [],
            },
            {
                headerName: 'SSN',
                field: 'employee_tin',
                maxWidth: 170,
                minWidth: 140,
                editable: false,
                sortable: true,
                filter: true,
                hide: true,
                valueGetter: (params) => params.data.id ? (this.privateSSN.find((a) => a.id === params.data.id) || {}).tin : '',
                valueFormatter: (params) => {
                    // If masked, the tin will be 6 characters long
                    if (!params.value) {
                        return '';    
                    } else if (params.value.length > 6) {
                        const numericTin = params.value.replace(/\D/g,'');
                        if (numericTin && numericTin.length === 9) {
                            return numericTin.substring(0, 3) + '-' + numericTin.substring(3, 5) + '-' + numericTin.substring(5, 13)
                        } else {
                            return 'Invalid TIN';
                        }
                    } else {
                        // Masked already
                        return params.value;
                    }
                },
                menuTabs: [],
            },
            {
                headerName: 'Loanout',
                field: 'loanout_name',
                colId: 'loanout_name',
                maxWidth: 300,
                minWidth: 100,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => parseInt(params.data.loanout_status) > 0 ? params.data.loanout_name : '',
                menuTabs: [],
            },
            {
                headerName: 'Position',
                field: 'job_title_override',
                colId: 'job_title_override',
                maxWidth: 500,
                minWidth: 250,
                editable: false,
                sortable: true,
                filter: true,
                cellRenderer: (params) => params.data.job_title_override ? `<span class="fakelink">${params.data.job_title_override}</span>` : '',
                valueGetter: (params) => params.data.job_title_override,
                menuTabs: [],
            },
            {
                headerName: 'Department',
                field: 'department',
                colId: 'department',
                maxWidth: 250,
                minWidth: 100,
                editable: false,
                sortable: true,
                comparator: this.caseInsensitiveComp,
                filter: true,
                valueGetter: (params) => params.data.department,
                menuTabs: [],
            },
            {
                headerName: 'On Project',
                field: 'active_project',
                colId: 'active_project',
                maxWidth: 100,
                minWidth: 10,
                editable: false,
                sortable: true,
                // comparator: this.caseInsensitiveComp,
                filter: true,
                hide: true,
                cellRenderer: (params) => `<span class="fakelink">${params.value}</span>`,
                valueGetter: (params) => params.data.active_project && params.data.active_project > 0 ? 'Yes' : 'No',
                menuTabs: [],
            },
            {
                headerName: 'Overrides',
                field: 'override_count',
                colId: 'override_count',
                maxWidth: 100,
                minWidth: 50,
                editable: false,
                sortable: true,
                // comparator: this.caseInsensitiveComp,
                filter: true,
                hide: true,
                cellRenderer: (params) => `<span class="fakelink">${params.value}</span>`,
                valueGetter: (params) => params.data.override_count && params.data.override_count > 0 ? 'Yes' : 'No',
                menuTabs: [],
            },
            {
                headerName: 'Rate',
                field: 'rate',
                colId: 'rate',
                maxWidth: 100,
                minWidth: 70,
                cellClass: 't-right',
                editable: false,
                sortable: true,
                hide: true,
                filter: 'agNumberColumnFilter',
                filter: true,
                filterParams: { valueFormatter: this.localValueFormatter },
                valueGetter: (params) => parseFloat(params.data.rate || 0),
                valueFormatter: (params) => params.value.formatNumber(null, 2),
                menuTabs: [],
            },
            {
                headerName: 'Rate Unit',
                field: 'rate_unit',
                colId: 'rate_unit',
                maxWidth: 100,
                minWidth: 70,
                editable: false,
                sortable: true,
                hide: true,
                filter: true,
                filterParams: { valueFormatter: this.localValueFormatter },
                valueGetter: (params) => params.data.rate_unit,
                menuTabs: [],
            },
            {
                headerName: 'Hourly Rate',
                field: 'hourly_rate',
                colId: 'hourly_rate',
                maxWidth: 150,
                minWidth: 70,
                cellClass: 't-right',
                editable: false,
                sortable: true,
                hide: true,
                filter: 'agNumberColumnFilter',
                filterParams: { valueFormatter: this.localValueFormatter },
                valueGetter: (params) => parseFloat(params.data.hourly_rate || 0),
                valueFormatter: (params) => typeof(params.value) === 'number' && params.value > 0 ? params.value.formatNumber(null, 4) : 'N/A',
                menuTabs: [],
            },
            {
                headerName: 'Local',
                field: 'union_local',
                colId: 'union_local',
                maxWidth: 150,
                minWidth: 70,
                editable: false,
                sortable: true,
                filter: true,
                filterParams: { valueFormatter: this.localValueFormatter },
                valueGetter: (params) => params.data.union_local,
                menuTabs: [],
            },
            {
                headerName: 'Dues',
                field: 'union_dues_withholding',
                colId: 'union_dues_withholding',
                maxWidth: 100,
                minWidth: 50,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => params.data.union_dues_withholding,
                menuTabs: [],
            },
            {
                headerName: 'Member',
                field: 'union_member',
                colId: 'union_member',
                maxWidth: 100,
                minWidth: 50,
                editable: false,
                sortable: true,
                filter: true,
                hide: !this.isCanada,
                valueGetter: (params) => params.data.union_member,
                menuTabs: [],
            },
            {
                headerName: 'Job Location',
                field: 'location',
                colId: 'location',
                maxWidth: 300,
                minWidth: 100,
                initialWidth: 120,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => params.data.location,
                menuTabs: [],
            },
            {
                headerName: 'Hired From',
                field: 'union_hired_from',
                colId: 'union_hired_from',
                maxWidth: 100,
                minWidth: 50,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => params.data.union_hired_from,
                menuTabs: [],
            },
            {
                headerName: 'Res State',
                field: 'employee_state_code',
                colId: 'employee_state_code',
                maxWidth: 100,
                minWidth: 50,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => params.data.employee_state_code,
                menuTabs: [],
            },
            {
                headerName: 'Account',
                field: 'budget_code',
                colId: 'budget_code',
                maxWidth: 250,
                minWidth: 70,
                width: 70,
                editable: false,
                sortable: true,
                comparator: this.caseInsensitiveComp,
                filter: true,
                valueGetter: (params) => params.data.budget_code,
                valueSetter: (params) => {
                    if (!params || typeof params.newValue === 'undefined') return null
                    params.data.budget_code = params.newValue
                    // console.log(params, params.data)
                },
                menuTabs: [],
            },
            {
                headerName: 'Fringe',
                field: 'fringe_code',
                colId: 'fringe_code',
                maxWidth: 250,
                minWidth: 70,
                width: 70,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => params.data.fringe_code,
                menuTabs: [],
            },
            {
                headerName: 'Series',
                field: 'series_code',
                colId: 'series_code',
                maxWidth: 250,
                minWidth: 70,
                width: 70,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => params.data.series_code,
                menuTabs: [],
            },
            {
                headerName: 'Location',
                field: 'location_code',
                colId: 'location_code',
                maxWidth: 250,
                minWidth: 70,
                width: 70,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => params.data.location_code,
                menuTabs: [],
            },
            {
                headerName: 'Set',
                field: 'set_code',
                colId: 'set_code',
                maxWidth: 250,
                minWidth: 70,
                width: 70,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => params.data.set_code,
                menuTabs: [],
            },
            {
                headerName: 'FF1',
                field: 'free_field',
                colId: 'free_field',
                maxWidth: 250,
                minWidth: 70,
                width: 70,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => params.data.free_field,
                menuTabs: [],
            },
            {
                headerName: 'FF2',
                field: 'free_field2',
                colId: 'free_field2',
                maxWidth: 250,
                minWidth: 70,
                width: 70,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => params.data.free_field2,
                menuTabs: [],
            },
            {
                headerName: 'Status',
                field: 'status_full',
                colId: 'status_full',
                maxWidth: 200,
                minWidth: 100,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => params.data.status_full,
                menuTabs: [],
            },
            {
                headerName: 'Hire Date',
                field: 'start_date',
                colId: 'start_date',
                maxWidth: 100,
                minWidth: 100,
                width: 100,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    if (!params.data.start_date) return null
                    const date = new Date(params.data.start_date)
                    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).toISOString().split('T')[0];
                },
                menuTabs: [],
            },
            {
                headerName: 'End Date',
                field: 'term_date',
                colId: 'term_date',
                maxWidth: 100,
                minWidth: 100,
                width: 100,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    if (!params.data.term_date) return null
                    const date = new Date(params.data.term_date)
                    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).toISOString().split('T')[0];
                },
                menuTabs: [],
            },
            {
                headerName: 'Email',
                field: 'Email',
                colId: 'Email',
                maxWidth: 200,
                minWidth: 100,
                editable: false,
                sortable: true,
                filter: true,
                comparator: this.caseInsensitiveComp,
                valueGetter: (params) => params.data.email,
                menuTabs: [],
            },
            {
                headerName: 'Phone',
                field: 'phone',
                colId: 'phone',
                maxWidth: 200,
                minWidth: 100,
                editable: false,
                sortable: true,
                filter: true,
                valueFormatter: (params) => {
                    if (!params.data || !params.data.phone) return
                    const phoneString = String(params.data.phone);
                    const phoneDigits = String(phoneString.replace(/\D/g, ''));
                    let result

                    if (phoneString.substring(0, 1) === '\+') {
                        result = phoneString;
                    } else if (phoneDigits.substring(0, 1) === '1' && phoneDigits.length === 11) {
                        result = `(${phoneDigits.substring(1, 4)}) ${phoneDigits.substring(4, 7)}-${phoneDigits.substring(7, 11)}`;
                    } else if (phoneDigits.length === 10) {
                        result = `(${phoneDigits.substring(0, 3)}) ${phoneDigits.substring(3, 6)}-${phoneDigits.substring(6, 10)}`;
                    } else {
                        result = phoneString;
                    }
                    return result;
                },
                valueGetter: (params) => params.data.phone,
                menuTabs: [],
            },
            {
                headerName: 'Date Added',
                field: 'time_added',
                colId: 'time_added',
                maxWidth: 150,
                minWidth: 100,
                width: 150,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    if (!params.data.time_added) return null
                    // to make local time from UTC.
                    const date = new Date(params.data.time_added + "Z");
                    // to make YYYY-MM-DD format.
                    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).toISOString().split('T')[0];
                },
                menuTabs: [],
            },
        ];

        this.entityId = entityId;
        let COAObj = JSON.parse(window.localStorage.getItem(this.entityId + '#'));
        // If COA data is not loaded for unexpected reason in dashboard, will get COA data just in case here.
        if (!COAObj || (COAObj && COAObj.isLoaded == false)) {
            this.loadCOA();
        } else if ((COAObj.accounts && COAObj.accounts.length > 0) || (COAObj.freeFields && COAObj.freeFields.length > 0) || (COAObj.series && COAObj.series.length > 0) || (COAObj.locations && COAObj.locations.length > 0) || (COAObj.sets && COAObj.sets.length > 0)) {
            this.enableProBooks = true;
        } else {
            this.enableProBooks = false;
        }

        this.getAvailableForms();
    },

    async mounted() {
        setTimeout(() => { $('[data-toggle="tooltip"]').tooltip() }, 500);

        // Prevent back button from failing.
        history.pushState(null, document.referrer, location.href);
        window.onpopstate = function () {
            window.location.href = document.referrer;
        };

        this.propayHost = typeof propayHost !== 'undefined' ? propayHost : '';
        this.resetSearch();
        this.getRoster();
    },
});
</script>
